import cookieCompliance from "./directive";
import cookieModal from "./modal/";
import cookieModel from "./model";
import cookieFactory from "./factory";

const modul = angular
    .module("cookieCompliance", [cookieModal])

    .directive("cookieCompliance", cookieCompliance)
    .factory("cookieModel", cookieModel)
    .factory("cookieFactory", cookieFactory);

export default modul.name;
